import { render, staticRenderFns } from "./NcmFilterBar.vue?vue&type=template&id=90bea672"
import script from "./NcmFilterBar.vue?vue&type=script&lang=js"
export * from "./NcmFilterBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports